import { Box, Typography, useTheme } from "@mui/material";
import { FC } from "react";
import { useLocalization } from "../../../hooks/useLocalization";

interface PasswordValidationOverviewProps {
  passwordCriteria: {
    minLength: boolean;
    lowercase: boolean;
    uppercase: boolean;
    number: boolean;
    special: boolean;
  };
  passwordRestrictions: {
    invalidCharacter: boolean;
    containsJobTitle: boolean;
    containsEmail: boolean;
    containsName: boolean;
  };
}

export const PasswordValidationOverview: FC<
  PasswordValidationOverviewProps
> = ({ passwordCriteria, passwordRestrictions }) => {
  const theme = useTheme();
  const { t } = useLocalization();
  const defaultTextColor = theme.colors.text[1];
  const criteriaMetColor = theme.colors.green;
  const restrictionMetColor = theme.colors.red;

  return (
    <Box sx={{ mt: 1, mb: 1 }}>
      <Box sx={{ display: "flex", gap: 3 }}>
        {/* Must contain */}
        <Box sx={{ flex: 1 }}>
          <Box sx={{ ml: 1 }}>
            <Typography
              sx={{
                fontSize: 11,
                color: passwordCriteria.minLength
                  ? criteriaMetColor
                  : defaultTextColor,
                mb: 0.5,
              }}
            >
              • {t("passwordValidation.criteria.minLength")}
            </Typography>
            <Typography
              sx={{
                fontSize: 11,
                color: passwordCriteria.lowercase
                  ? criteriaMetColor
                  : defaultTextColor,
                mb: 0.5,
              }}
            >
              • {t("passwordValidation.criteria.lowercase")}
            </Typography>
            <Typography
              sx={{
                fontSize: 11,
                color: passwordCriteria.uppercase
                  ? criteriaMetColor
                  : defaultTextColor,
                mb: 0.5,
              }}
            >
              • {t("passwordValidation.criteria.uppercase")}
            </Typography>
            <Typography
              sx={{
                fontSize: 11,
                color: passwordCriteria.number
                  ? criteriaMetColor
                  : defaultTextColor,
                mb: 0.5,
              }}
            >
              • {t("passwordValidation.criteria.number")}
            </Typography>
            <Typography
              sx={{
                fontSize: 11,
                color: passwordCriteria.special
                  ? criteriaMetColor
                  : defaultTextColor,
              }}
            >
              • {t("passwordValidation.criteria.special")}
            </Typography>
          </Box>
        </Box>

        {/* Should NOT contain */}
        <Box sx={{ flex: 1 }}>
          <Box sx={{ ml: 1 }}>
            <Typography
              sx={{
                fontSize: 11,
                color: passwordRestrictions.invalidCharacter
                  ? restrictionMetColor
                  : defaultTextColor,
                mb: 0.5,
              }}
            >
              • {t("passwordValidation.restrictions.invalidCharacter")}
            </Typography>
            <Typography
              sx={{
                fontSize: 11,
                color: passwordRestrictions.containsJobTitle
                  ? restrictionMetColor
                  : defaultTextColor,
                mb: 0.5,
              }}
            >
              • {t("passwordValidation.restrictions.containsJobTitle")}
            </Typography>
            <Typography
              sx={{
                fontSize: 11,
                color: passwordRestrictions.containsEmail
                  ? restrictionMetColor
                  : defaultTextColor,
                mb: 0.5,
              }}
            >
              • {t("passwordValidation.restrictions.containsEmail")}
            </Typography>
            <Typography
              sx={{
                fontSize: 11,
                color: passwordRestrictions.containsName
                  ? restrictionMetColor
                  : defaultTextColor,
              }}
            >
              • {t("passwordValidation.restrictions.containsName")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
